import {
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Text,
  Title,
  Paper,
  Card,
  Group,
  ThemeIcon,
  SimpleGrid,
  Divider,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBuildingSkyscraper,
  IconCalendar,
  IconDatabaseExport,
  IconSearch,
  IconFileSpreadsheet,
  IconReportAnalytics,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { BASE_API_POS } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const ExportExcel = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [search, setSearch] = useState<any>({
    tuNgay: _searchJson && checkedPinSearch ? _searchJson?.tuNgay : "",
    denNgay: _searchJson && checkedPinSearch ? _searchJson?.denNgay : "",
    maCnList: _searchJson && checkedPinSearch ? _searchJson?.maCnList : [],
  });

  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));
      setDataBranch(data);
    }
  };

  const exportDsTheoSerial = async () => {
    open();
    try {
      const params = new URLSearchParams();

      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (
          value !== undefined &&
          value !== null &&
          String(value).length > 0
        ) {
          params.append(key, String(value));
        }
      });

      const queryString = params.toString();
      const suffix = queryString ? `?${queryString}` : "";

      const baseUrl = `/api/v1/BcExport/export-ds-theo-serial${suffix}`;
      const _url = BASE_API_POS + baseUrl;

      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          // Thay đổi Content-Type thành Accept theo chuẩn cURL cho request GET tải file
          Accept: "*/*",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });

      if (!response.ok) {
        // Cập nhật lại thông báo lỗi cho chuẩn với ngữ cảnh
        NotificationExtension.Fails("Export báo cáo thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);

        // Đổi đuôi file tải về thành .zip
        const filename = "bao_cao_doanh_so_theo_serial.zip";

        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(urlss);
        // Cập nhật lại thông báo thành công
        NotificationExtension.Success("Export báo cáo thành công !");
      }
    } catch (error) {
      console.error(error);
    } finally {
      close();
    }
  };

  const exportInvCountTrans = async () => {
    open();
    try {
      const params = new URLSearchParams();

      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (
          value !== undefined &&
          value !== null &&
          String(value).length > 0
        ) {
          params.append(key, String(value));
        }
      });

      const queryString = params.toString();
      const suffix = queryString ? `?${queryString}` : "";

      const baseUrl = `/api/v1/BcExport/export-inv-count-trans${suffix}`;
      const _url = BASE_API_POS + baseUrl;

      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export báo cáo thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const filename = "bao_cao_giao_dich_kho.zip";

        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(urlss);
        NotificationExtension.Success("Export báo cáo thành công !");
      }
    } catch (error) {
      console.error(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  return (
    <div ref={headerRef} style={{ width: "100%" }}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              <Title order={5}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />

      <_breadcrumb />

      {/* --- BỘ LỌC TÌM KIẾM --- */}
      <Paper withBorder shadow="sm" p="md" radius="md" mb="xl" mt="md">
        <Text fw={600} size="lg" mb="md">
          Bộ lọc dữ liệu
        </Text>
        <Grid align="flex-end">
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <DatePickerInput
              size="sm"
              label="Ngày bắt đầu"
              placeholder="Chọn ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.tuNgay && search.tuNgay?.length > 0
                  ? new Date(search.tuNgay ?? "")
                  : null
              }
              maxDate={
                search.denNgay && search.denNgay?.length > 0
                  ? new Date(search.denNgay)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "tuNgay",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar size={18} color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 3, lg: 2 }}>
            <DatePickerInput
              size="sm"
              label="Ngày kết thúc"
              placeholder="Chọn ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.denNgay && search.denNgay?.length > 0
                  ? new Date(search.denNgay ?? "")
                  : null
              }
              minDate={
                search.tuNgay && search.tuNgay?.length > 0
                  ? new Date(search.tuNgay)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "denNgay",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar size={18} color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 8 }}>
            <MultiSelect
              label="Chi nhánh"
              placeholder="Chọn chi nhánh"
              leftSection={<IconBuildingSkyscraper size={18} color="#15aabf" />}
              data={dataBranch}
              value={search.maCnList || []}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "maCnList", setSearch);
              }}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
        </Grid>
      </Paper>

      {/* --- DANH SÁCH BÁO CÁO (EXPORT) --- */}
      <Text fw={600} size="lg" mb="md">
        Danh sách
      </Text>
      <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
        {/* Card 1 */}
        <Card withBorder shadow="sm" padding="lg" radius="md">
          <Group justify="space-between" wrap="nowrap">
            <Group wrap="nowrap">
              <ThemeIcon size="xl" variant="light" color="blue" radius="md">
                <IconFileSpreadsheet size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600}>Báo cáo doanh số theo serial</Text>
                <Text size="sm" c="dimmed">
                  Kết xuất dữ liệu chi tiết về doanh thu của các serial bán ra
                </Text>
              </div>
            </Group>
            <Button
              variant="light"
              color="blue"
              leftSection={<IconDatabaseExport size={18} />}
              onClick={() => exportDsTheoSerial()}
            >
              Export
            </Button>
          </Group>
        </Card>

        {/* Card 2 */}
        <Card withBorder shadow="sm" padding="lg" radius="md">
          <Group justify="space-between" wrap="nowrap">
            <Group wrap="nowrap">
              <ThemeIcon size="xl" variant="light" color="teal" radius="md">
                <IconReportAnalytics size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600}>Báo cáo giao dịch kho</Text>
                <Text size="sm" c="dimmed">
                  Kết xuất dữ liệu lịch sử xuất/nhập/tồn kho
                </Text>
              </div>
            </Group>
            <Button
              variant="light"
              color="teal"
              leftSection={<IconDatabaseExport size={18} />}
              onClick={() => exportInvCountTrans()}
            >
              Export
            </Button>
          </Group>
        </Card>
      </SimpleGrid>
    </div>
  );
};

export default ExportExcel;
